import React, { useState } from 'react'
import { Minus, Plus, Chevron } from '../Icons/Icons'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import Link from '../Link'
import Submenu from './Submenu'
import { menuItem as menuItemClass, link, darkToggle as darkToggleClass } from './classes'
import { CallToAction } from 'components/CallToAction'
import { Trans, useI18next, useTranslation } from 'gatsby-plugin-react-i18next'
import { RenderInClient } from 'components/RenderInClient'
import useiCloudReady from '../../hooks/useiCloudReady'
import { MenuItemType } from 'types'
import { Department, Location, Timezone } from 'components/NotProductIcons'
import { GlobalOutlined } from '@ant-design/icons'
import { DarkModeToggle2, DarkModeToggle } from 'components/DarkModeToggle'

export const MenuItemLink = ({
    menuItem = {},
    hovered,
    handleSubClick,
    urlOverride,
}: {
    menuItem: MenuItemType
    hovered: boolean
    handleSubClick: () => void
    urlOverride?: string
}): JSX.Element => {
    const breakpoints = useBreakpoint()
    const { title, title_ar, url, classes = '', icon, component } = menuItem
    let linkList = menuItem?.linkList
    if (linkList?.length == 1 && linkList[0]?.title == '') linkList = null
    const { language } = useI18next()

    return (
        <>
            <Link
                onClick={breakpoints.md && linkList ? handleSubClick : undefined}
                to={urlOverride || url}
                className={link(classes, linkList && hovered)}
            >
                {icon || title == 'Change language' ? (
                    //   <GlobalOutlined style={{ marginRight: '8px', verticalAlign: 'unset', }} />
                    <>
                        <span className="h-6 w-6  dark:text-white">{<GlobalOutlined />}</span>
                        <span>{language.toString()}</span>
                    </>
                ) : (
                    <span>{title}</span>
                )}
                {linkList && !breakpoints.md && (
                    <Chevron className="mt-1 -ml-3 w-[10px] text-black/25 dark:text-white/50" />
                )}
            </Link>
        </>
    )
}

export default function MenuItem({
    menuItem,
    referenceElement,
}: {
    menuItem: MenuItemType
    referenceElement: any
}): JSX.Element {
    const [hovered, setHovered] = useState(false)
    const { url, title, title_ar, hideBorder, cta, toggle, classes = '', component } = menuItem
    let linkList = menuItem?.linkList
    if (linkList?.length == 1 && linkList[0]?.title == '') linkList = null
    const icloudready = useiCloudReady()
    const breakpoints = useBreakpoint()
    const { i18n } = useTranslation()
    // const title = menuItem?.title,
    //     direction = ''
    // if (title != '' && menuItem.title_ar != '' && i18n.language === 'ar') {
    //     menuItem.title = menuItem.title_ar
    //     menuItem.direction = 'rtl'
    // }
    const handleSubClick = () => {
        setHovered(!hovered)
    }
    // dir = {menuItem.direction || ""}

    return (
        <li
            onMouseEnter={() => !breakpoints.md && setHovered(true)}
            onMouseLeave={(e) => !e.target.shadowRoot && !breakpoints.md && setHovered(false)}
            className={menuItemClass(hideBorder)}
        >
            <span className="flex items-center justify-between">
                {cta ? (
                    <CallToAction
                        size="sm"
                        onClick={breakpoints.md && linkList ? handleSubClick : undefined}
                        to={url}
                        className={`mx-auto lg:mx-0 ${classes}`}
                    >
                        {/* {i18n.language === 'ar' && title_ar} */}
                        {/* {i18n.language === 'en' && title} */}
                        {title}
                    </CallToAction>
                ) : toggle ? (
                    <DarkModeToggle2 />
                ) : (
                    <MenuItemLink menuItem={menuItem} hovered={hovered} handleSubClick={handleSubClick} />
                )}
                {linkList && breakpoints.md && (
                    <button
                        className={`rounded- mr-4 flex flex-grow justify-end text-primary dark:text-primary-dark`}
                        onClick={handleSubClick}
                    >
                        {hovered ? <Minus /> : <Plus />}
                    </button>
                )}
            </span>

            {linkList && hovered && (
                <Submenu
                    referenceElement={referenceElement}
                    component={component}
                    menuItem={menuItem}
                    parentURL={url}
                />
            )}
        </li>
    )
}
